/* eslint import/prefer-default-export:off */
import { getJSON } from 'bv-fetch';
import { locale } from 'bv-i18n';

export const apiFetchEvent = ({ eventId }) => (
  getJSON(`/api/sportsbook/events/${eventId}`, {
    c: locale(),
  }).catch(() => null)
);
